import { render, staticRenderFns } from "./CommunityOptions.vue?vue&type=template&id=17614976&"
import script from "./CommunityOptions.vue?vue&type=script&lang=js&"
export * from "./CommunityOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports